var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetsNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "99px",
    viewBox: "0 0 100 99",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "73D6350E-EAA9-40E0-B45C-180472C8E054") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Marketing-support->-Logos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logos-CASE-no-results",
    transform: "translate(-969.000000, -578.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(769.000000, 578.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "manual-no-results-100pxheight",
    transform: "translate(200.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#F0F0F0",
    strokeWidth: 6,
    fill: "#FFFFFF",
    cx: 50,
    cy: 49.0148025,
    rx: 47,
    ry: 46.0148025
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2251215,55.8805841 C46.4455385,54.1430758 46.7179682,52.8968974 47.0424107,52.142049 C47.8013431,50.3763159 49.1908381,48.6372013 51.2109375,46.924653 C53.2310369,45.2121047 54.5758895,43.8186857 55.2455357,42.7443541 C55.9151819,41.6700226 56.25,40.5372048 56.25,39.3458668 C56.25,35.7505791 54.508946,33.9529621 51.0267857,33.9529621 C49.3749917,33.9529621 48.0524603,34.4369359 47.0591518,35.404898 C46.7314732,35.7242151 46.438866,36.2123901 46.18133,36.869423 C45.5807419,38.4016768 44.1029529,39.4096882 42.4571984,39.4096882 L40.6473214,39.4096882 C38.5855885,39.4096882 36.9142237,37.7383234 36.9142237,35.6765904 C36.9142237,35.2350003 36.9925728,34.7969127 37.1456733,34.3827122 C37.9193875,32.2887944 38.8466482,30.7840221 39.9274554,29.8683953 C42.6395225,27.5708149 46.3392623,26.422042 51.0267857,26.422042 C55.7589522,26.422042 59.4307905,27.5123126 62.0424107,29.6928865 C64.6540309,31.8734605 65.9598214,34.9528102 65.9598214,38.931028 C65.9598214,40.7393088 65.5357185,42.4465131 64.6875,44.0526919 C63.8392815,45.6588708 62.3549213,47.4405325 60.234375,49.3977306 L57.5223214,51.8548529 C55.8258844,53.407847 54.8549119,55.2267375 54.609375,57.3115789 C54.5339661,58.4075911 53.6228964,59.2581303 52.5242931,59.2581303 L49.2012532,59.2581303 C47.5444081,59.2581138 46.2012697,57.9149755 46.2012697,56.2581303 C46.2012697,56.1319051 46.2092362,56.0058057 46.2251215,55.8805841 Z M44.9330357,69.0547087 C44.9330357,67.6293579 45.4408431,66.453993 46.4564732,65.5285787 C47.4721033,64.6031644 48.7723135,64.1404642 50.3571429,64.1404642 C51.9419722,64.1404642 53.2421824,64.6031644 54.2578125,65.5285787 C55.2734426,66.453993 55.78125,67.6293579 55.78125,69.0547087 C55.78125,70.4587856 55.2846032,71.6181953 54.2912946,72.5329727 C53.2979861,73.44775 51.9866153,73.9051318 50.3571429,73.9051318 C48.7276704,73.9051318 47.4162996,73.44775 46.4229911,72.5329727 C45.4296825,71.6181953 44.9330357,70.4587856 44.9330357,69.0547087 Z",
    id: "?",
    fill: "#EDEDED",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsNoResults);
export default __webpack_public_path__ + "static/media/assets-no-results.c7e08b0e4280153f1f1a38bdc657a5e5.svg";
export { ForwardRef as ReactComponent };